import { apiServices } from "redux/utils/api_services";
const checkAndRenderImage = (imageToCheck, language) => {
  let imageUrl;
  try {
    const renderedImage = `${apiServices?.image_cdn}TC/localization_images/${language}/${imageToCheck}`;
    imageUrl = renderedImage;
  } catch (error) {
    imageUrl = `${apiServices?.image_cdn}TC/localization_images/en_US/${imageToCheck}`;
  }
  return imageUrl;
};
// * -- localization images config
export const imageConfig = {
  en_US: {
    'connect-slide': checkAndRenderImage('connect-slide.png', 'en_US'),
    'build-charts-slide': checkAndRenderImage('build-charts-slide.png', 'en_US'),
    'analyze-metrics-slide': checkAndRenderImage('analyze-metrics-slide.png', 'en_US'),
    'ads-data-slide': checkAndRenderImage('ads-data-slide.png', 'en_US')
  },
  in_ID: {
    'connect-slide': checkAndRenderImage('connect-slide.png', 'in_ID'),
    'build-charts-slide': checkAndRenderImage('build-charts-slide.png', 'in_ID'),
    'analyze-metrics-slide': checkAndRenderImage('analyze-metrics-slide.png', 'in_ID'),
    'ads-data-slide': checkAndRenderImage('ads-data-slide.png', 'in_ID')
  },
  th_TH: {
    'connect-slide': checkAndRenderImage('connect-slide.png', 'th_TH'),
    'build-charts-slide': checkAndRenderImage('build-charts-slide.png', 'th_TH'),
    'analyze-metrics-slide': checkAndRenderImage('analyze-metrics-slide.png', 'th_TH'),
    'ads-data-slide': checkAndRenderImage('ads-data-slide.png', 'th_TH')
  }
};
